module.exports = __webpack_public_path__ + "img/folder.56cecf09.svg";